/**
 * @generated SignedSource<<ad00b4b3c871d022b4a57fc57277b2af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MembershipRoleKindEnumType = "admin" | "coordinator" | "general" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Members_MembersConnection$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly id: string;
    readonly kind: MembershipRoleKindEnumType | null | undefined;
    readonly node: {
      readonly email: string;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "Members_MembersConnection";
};
export type Members_MembersConnection$key = {
  readonly " $data"?: Members_MembersConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"Members_MembersConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Members_MembersConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClubUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ClubUserConnection",
  "abstractKey": null
};
})();

(node as any).hash = "c9e74877a509405cd6b7a2cf54c6373f";

export default node;
